import React from "react";

import Form from "@Components/Form";
import { URLS, ID_TYPES_URL, STORAGE_CONSTANT } from "configs/constants";
import { getAssignedModule } from "../../../utils";

const initialValues = {
  // status: "",
  name: "",
  active: true,
};

const IdTypeForm = () => {
  let formFields = [
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
      disabledText: ["Passport", "IC"],
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "switch",
      name: "active",
      label: "Active?",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
    });
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={ID_TYPES_URL}
      listRoute={URLS.ID_TYPE_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="ID Type"
    />
  );
};

export default IdTypeForm;
